export default __webpack_public_path__ + "static/media/noun_Battery_-2.a48b8f1e.svg";